var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "step4",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                  change: function ($event) {
                    return _vm.formChanged()
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Cost Price",
                              "label-for": "h-number",
                              "label-cols-md": "4",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Total Cost (Rs)",
                                vid: "purchasePrice",
                                rules: "required|min_value:0",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "h-number",
                                            type: "number",
                                            value: "5982",
                                            "min_value:0": "",
                                            required: "",
                                          },
                                          on: {
                                            keypress: function ($event) {
                                              return _vm.allowOnlyNumbers(
                                                $event
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.sanitizeInput(
                                                "purchasePrice"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.Product.purchasePrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.Product,
                                                "purchasePrice",
                                                $$v
                                              )
                                            },
                                            expression: "Product.purchasePrice",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Selling Price (Tax Exclusive)",
                              "label-for": "h-Selling",
                              "label-cols-md": "4",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Selling Price (Tax Exclusive)",
                                rules: "min_value:0",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "h-Mark",
                                            type: "number",
                                            placeholder: "Rs 6895",
                                          },
                                          on: {
                                            keypress: function ($event) {
                                              return _vm.allowOnlyNumbers(
                                                $event
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.sanitizeInput(
                                                "salePrice"
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.Product.salePrice,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.Product,
                                                "salePrice",
                                                $$v
                                              )
                                            },
                                            expression: "Product.salePrice",
                                          },
                                        }),
                                        errors.length
                                          ? _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.vat
                      ? _c(
                          "b-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Sales VAT (%)",
                                  "label-for": "h-VAT",
                                  "label-cols-md": "4",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "Sales VAT (%)",
                                    rules: "min_value:0",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              attrs: {
                                                id: "h-Mark",
                                                type: "number",
                                                placeholder: "Ex : 15%",
                                              },
                                              on: {
                                                keypress: function ($event) {
                                                  return _vm.allowOnlyNumbers(
                                                    $event
                                                  )
                                                },
                                                input: function ($event) {
                                                  return _vm.sanitizeInput(
                                                    "saleTaxPercentage"
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.Product.saleTaxPercentage,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.Product,
                                                    "saleTaxPercentage",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "Product.saleTaxPercentage",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Mark Up (%)",
                              "label-for": "h-password",
                              "label-cols-md": "4",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "h-Mark",
                                disabled: "",
                                type: "number",
                                placeholder: "",
                              },
                              model: {
                                value: _vm.Product.markUpPercentage,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Product, "markUpPercentage", $$v)
                                },
                                expression: "Product.markUpPercentage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }